function Counter({ value }) {
  return (
    <div className="ml-auto my-auto">
      <div className="text-sm h-8 w-8 bg-neutral-200 my-auto mx-3 rounded-full flex items-center justify-center text-neutral-500 ">
        {value || 0}
      </div>
    </div>
  );
}

export default Counter;
